module.exports = __webpack_public_path__ + "static/img/cont48 (1).cf4dc47.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont48 (1).jpg
// module id = xXXp
// module chunks = 0